import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TwoDigitDecimaNumberDirective } from './two-digit/two-digit-decima-number.directive';
import { DocumentClickDirective } from './document-click/document-click.directive';
import { SpecialCharsDirective } from './special-chars/special-chars.directive';
import { NumericDirective } from './numeric/numeric.directive';

@NgModule({
  declarations: [TwoDigitDecimaNumberDirective, DocumentClickDirective, SpecialCharsDirective, NumericDirective],
  imports: [
    CommonModule
  ],
  exports: [TwoDigitDecimaNumberDirective, DocumentClickDirective, NumericDirective]
})
export class DirectivesModule { }
